export default __webpack_public_path__ + "static/media/cleIButton.28fbf090.png";